import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import logo from '../assets/images/sunshinelogo2.png';
import "../styles/Contact.css";

const serviceLinks = [
  "Window Cleaning",
  "Steam Carpet and Furniture Cleaning",
  "Disinfecting Office Cleaning",
  "Pressure Washing",
  "House Cleaning",
  "New Construction Cleaning"
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__grid">
          {/* Información de la empresa */}
          <div>
            <div className="site-footer__brand">
              <img src={logo} alt="" />
              <b>Sunshine<br />Cleaning All</b>
            </div>
            <p>
              Professional cleaning services for homes and offices across Los
              Angeles County. Committed to excellence and customer satisfaction.
            </p>
          </div>

          {/* Información de contacto */}
          <div>
            <h3>Contact</h3>
            <ul>
              <li className="site-footer__row">
                <Phone size={16} aria-hidden="true" />
                <a href="tel:+13109254824" className="mono">(310) 925-4824</a>
              </li>
              <li className="site-footer__row">
                <Mail size={16} aria-hidden="true" />
                <a href="mailto:info@sunshinecleaningall.com">
                  info@sunshinecleaningall.com
                </a>
              </li>
              <li className="site-footer__row">
                <MapPin size={16} aria-hidden="true" />
                <span>Los Angeles, CA</span>
              </li>
              <li className="site-footer__row">
                <Clock size={16} aria-hidden="true" />
                <span className="mono">Available 24/7</span>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h3>Our services</h3>
            <ul>
              {serviceLinks.map((service) => (
                <li key={service}>
                  <a href="#Services">{service}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="site-footer__base">
          <p>© 2026 Sunshine Cleaning. All rights reserved.</p>
          <p>
            Developed by Dilan Castro
            <br />
            dilancastro7@hotmail.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
